import { render } from "./ComAttatchmentButton.vue?vue&type=template&id=3f5a95a2&ts=true"
import script from "./ComAttatchmentButton.vue?vue&type=script&lang=ts"
export * from "./ComAttatchmentButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__